import { ContactType } from "../../../utils/contacts"
import Contact, { ContactDto } from "../../contact/models/contact"
import { Entity } from "../../helpers/Entity"

export type CustomerAccountAttributesDto = {
    contactType: ContactType,
    owingBalance: string,
    globalBalance: string,
    contact: ContactDto
}

export type CustomerAccountDto = {
    id: string
    type: string
    attributes: CustomerAccountAttributesDto
}

export default class CustomerAccount implements Entity {
    private dto: CustomerAccountDto
    private contact: Contact

    constructor(dto: CustomerAccountDto) {
        this.dto = dto
        this.contact = new Contact(dto.attributes.contact)
    }

    isLoaded(): boolean {
        return this.dto.type === "customer-accounts"
    }

    getId(): string {
        return this.dto.id
    }

    getDto() : CustomerAccountDto {
        return this.dto
    }

    getOwingBalance(): string {
        return this.dto.attributes.owingBalance
    }

    getGlobalBalance(): string {
        return this.dto.attributes.globalBalance
    }

    getCreditLimit(): number {
        return this.contact.getCreditLimit()
    }

    getCustomerAccountIds() : string[] {
        return this.contact.getCustomerAccountIds()
    }

    getContactType() : string {
        return this.contact.getType()
    }

    getContact() : Contact {
        return this.contact
    }
}


// WEBPACK FOOTER //
// ./src/state/customer-account/models/CustomerAccount.ts